// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/owl.carousel.min.css
// module id = 27
// module chunks = 0